import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const { NotificationTabs } = loadable(() => import('../components/Notification/NotificationTabs'));
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('NotificationTabs own props', ownProps);
    return {
        contextCustomer: state.AppReducer.contextCustomer,
        user: state.AppReducer.user,
        userGroupRoles: state.AppReducer.userGroupRoles,
        userSelectedGroup: state.AppReducer.userSelectedGroup,
        roleArbitrationInstance: state.AppReducer.roleArbitrationInstance,
        isSmallView: state.AppReducer.isSmallView,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('NotificationTabs Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(NotificationTabs);
